import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestDeployInstanceDialogComponent } from './request-deploy-instance-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDividerModule } from '@angular/material/divider';
import { DeployInstanceFormModule } from 'src/app/main/service/deploy-instance-form/deploy-instance-form.module';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorModule } from 'src/app/components/error/error.module';



@NgModule({
  declarations: [
    RequestDeployInstanceDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DeployInstanceFormModule,
    SidenavHeaderModule,
    ErrorModule,

    MatDividerModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    RequestDeployInstanceDialogComponent
  ],
})
export class RequestDeployInstanceDialogModule { }
